import { Router } from '@angular/router';
import { DialogService } from './dialog.service';
import { GlobalService } from './global.service';
import { JsonResult } from '../models/helper.model';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: "root"
})
export class PortaleFEService {

  public constructor(private http: HttpClient, private router: Router) { }

  registerCompanyFE(FK_Company: number): Promise<JsonResult> {
    let url = environment.apiFullUrl + '/PortaleFE/RegisterCompanyFE/' + FK_Company + "?ClientID=E1846FBA-641B-4663-973C-6CED1D778EF9";
    return this.http.get<JsonResult>(url).toPromise();
  }

  updateAuthFE(FK_Company: number): Promise<any> {
    let url = environment.apiFullUrl + '/PortaleFE/UpdateAuthFE/' + FK_Company + "?ClientID=E1846FBA-641B-4663-973C-6CED1D778EF9";
    return this.http.get<any>(url).toPromise();
  }

  PortaleFEAuth(openUrl: boolean = true) {
    this.registerCompanyFE(GlobalService.getUsedCompany()).then(async (res) => {
      //Se mi torna null, l'azienda è correttamente registrata e posso impostare il flag a 1
      if (res == null) {
        await this.updateAuthFE(GlobalService.getUsedCompany());
      } else if (res.Value != null && openUrl == true) {
        window.open(res.Value.toString(), "_self");
      }
    }).catch((err) => {
      DialogService.Error(err.message);
      //In caso di errore, ricarico la pagina in modo da far vedere l'alert nel default layout
      this.reloadComponent();
    });
  }

  /**
 * Ricarico i dati
 **/
  reloadComponent() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([this.router.url]);
  }

  /**
   * Invoca l'API che processa la coda degli elementi 2C per l'azienda avente ID uguale al parametro fk_company.
   * @param fk_company ID dell'azienda per cui processare gli elementi della coda 2C
   * @returns
   */
  process2CQueueByCompany(fk_company: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + "/PortaleFE/Process2CQueueByCompany/" + fk_company).toPromise();
  }

  /**
   * Invoca l'API che effettua il download delle fatture attive dal portale 2c.
   * @param fk_company ID dell'azienda
   * DataStart / DataEnd range di date da scaricare
   * @returns
   */
  Import2cActiveInvoices(fk_company: number, datastart: Date, dataend: Date): Promise<any> {        
    // In questo modo perchè la todateString() non funziona
    const formattedDatastart = formatDate(datastart, 'MM-dd-yyyy', 'en-US'); // Convert date format
    const formattedDataEnd = formatDate(dataend, 'MM-dd-yyyy', 'en-US'); // Convert date format
    return this.http.get<any>(environment.apiFullUrl + "/PortaleFE/Import2cActiveInvoices/" + fk_company + "/" + formattedDatastart + "/" + formattedDataEnd).toPromise();
  }

  /**
   * Data l'FK_Company, restituisco il residuo delle fatture del cliente passato
   * @param fk_company
   * @returns
   */
  getServicePackage(fk_company: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + "/PortaleFE/GetServicePackage/" + fk_company).toPromise();
  }
}
